module.exports = __webpack_public_path__ + "static/media/home-icon.b804f732.png";